export const clamp = (value: number, min = 0, max = 1): number =>
  Math.min(max, Math.max(min, value));

/** Ramène `value` de [inMin, inMax] vers [0, 1], borné. */
export const progressBetween = (value: number, inMin: number, inMax: number): number =>
  clamp((value - inMin) / (inMax - inMin));

export const smoothstep = (value: number, edge0: number, edge1: number): number => {
  const t = progressBetween(value, edge0, edge1);
  return t * t * (3 - 2 * t);
};

export const lerp = (from: number, to: number, t: number): number => from + (to - from) * t;

/** Interpolation exponentielle indépendante du framerate. */
export const damp = (from: number, to: number, smoothing: number, delta: number): number =>
  lerp(from, to, 1 - Math.exp(-smoothing * delta));

export const easeInCubic = (t: number): number => t * t * t;

export const easeOutCubic = (t: number): number => 1 - (1 - t) ** 3;

export const easeInOutCubic = (t: number): number =>
  t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;

/** Interpolation géométrique : une distance qui fond à vitesse constante, comme un vrai rapprochement. */
export const approach = (from: number, to: number, t: number): number => from * (to / from) ** t;

/** Accélération et freinage réguliers : le mouvement part tout de suite, sans à-coup. */
export const easeInOutSine = (t: number): number => (1 - Math.cos(Math.PI * t)) / 2;
